import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { initialMapFiltersState } from "../../../widgets/map/mapAddons/mapOverlayWidget/waysideLandLotsOverlay/map.filters.config";

export type MapWaysideLandLotsFilters = {
    LayersToShow: any
    EncumbranceString: any,
    RightTypeId: any,
}

type MapWaysideLandLotsSlice = {
    filterMenuIsExpanded: boolean,
    filterMenuActiveTabs: number[],
    mapFiltersState: MapWaysideLandLotsFilters,
    appliedFilters: MapWaysideLandLotsFilters,
    mapFiltersExpressions: object | null,
    tableUnderMapFiltersExpressions: object | null
}

function getInitialState() {
    const mapsPreferences = getItemWebStorage("mapsPreferences")?.["WaysideLandLots"]
    const { mapFiltersState: localMapFiltersState, appliedFilters: localAppliedFilters, filterMenuActiveTabs: localFilterMenuActiveTabs } = mapsPreferences ?? {}
    const mapFiltersState: MapWaysideLandLotsFilters = localAppliedFilters
        ? localMapFiltersState as MapWaysideLandLotsFilters
        : initialMapFiltersState
    const initialState: MapWaysideLandLotsSlice = {
        filterMenuIsExpanded: false,
        filterMenuActiveTabs: localFilterMenuActiveTabs,
        mapFiltersState,
        appliedFilters: localAppliedFilters,
        mapFiltersExpressions: null,
        tableUnderMapFiltersExpressions: null,
    };
    return initialState
}

export const mapWaysideLandLotsSlice = createSlice({
    name: 'mapWaysideLandLots',
    initialState: getInitialState(),
    reducers: {
        setFilterMenuIsExpanded(state, action: PayloadAction<any>) {
            state.filterMenuIsExpanded = action.payload
        },
        setFilterMenuActiveTabs(state, action: PayloadAction<any>) {
            state.filterMenuActiveTabs = action.payload
        },
        setMapFiltersState(state, action: PayloadAction<any>) {
            state.mapFiltersState = action.payload
        },
        patchMapFiltersState(state, action: PayloadAction<{ fieldName: keyof MapWaysideLandLotsFilters, patch: any }>,
        ) {
            const { fieldName, patch } = action.payload;
            state.mapFiltersState[fieldName] = { ...state.mapFiltersState[fieldName], ...patch };
        },
        resetAllMapFilters(state) {
            state.mapFiltersState = structuredClone(initialMapFiltersState)
        },
        resetSingleMapFilter(state, action: PayloadAction<keyof MapWaysideLandLotsFilters>) {
            const fieldName = action.payload
            if (fieldName in initialMapFiltersState) {
                state.mapFiltersState[fieldName] = structuredClone(initialMapFiltersState[fieldName])
            }
        },
        setAppliedFilters(state, action: PayloadAction<any>) {
            state.appliedFilters = action.payload
        },
        setMapFiltersExpressions(state, action: PayloadAction<any>) {
            state.mapFiltersExpressions = action.payload
        },
        setTableUnderMapFiltersExpressions(state, action: PayloadAction<any>) {
            state.tableUnderMapFiltersExpressions = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setFilterMenuIsExpanded,
    setFilterMenuActiveTabs,
    setMapFiltersState,
    setAppliedFilters,
    patchMapFiltersState,
    resetAllMapFilters,
    resetSingleMapFilter,
    setMapFiltersExpressions,
    setTableUnderMapFiltersExpressions
} = mapWaysideLandLotsSlice.actions;
export const mapWaysideLandLotsReducer = mapWaysideLandLotsSlice.reducer;
